/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Monday , March 7th 2022, 10:10:07 am          #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */


import React, { useEffect, useState, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
  Alert
} from "reactstrap"

//**Importing required componant files   */
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPInfoBox from "framework/layout/DPInfoBox"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import DPPrintOption from "framework/widgets/DPPrintOptions"
import moment from 'moment';
import { getCustomerBundles, getSupplierBundles, getCompany, SKU, SKUBundle, getTickets, getPaymentModes, getPromotionLocations, savePromotion, getPriceModes } from "./PromotionController"
//**End Importing required componant files */


//Content related imports
import PromotionMasterGenContent from "./PromotionMasterGenContent"
import PromotionLocationContent from "./PromotionLocationContent"
import PromotionPaymentModeContent from "./PromotionPaymentModeContent"
import PromotionDetailsContent from "./PromotionDetailsContent"
import PromotionExcludeInclude from "./PromotionExcludeInclude"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import PromotionCouponContent from "./PromotionCouponContent"
import { PromotionGroupDetailsGetData } from "../Promotion-Group-Master/PromotionGroupController"
import { set } from "lodash"

const PromotionMaster = (props) => {

  var today = Date.now();
  var todaydate = moment(today).format("YYYY-MM-DD");
  const authToken = localStorage.getItem("authToken")

  //var todaytime = moment(today).format("HH:mm:ss");

  let history = useHistory();
  //**Set Values for Genaral Tab (Tab==1) */
  const [code, setCode] = useState('')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [datefrom, setDateFrom] = useState(todaydate)
  const [dateto, setDateTo] = useState(todaydate)
  const [timefrom, setTimeFrom] = useState('00:00:00')
  const [timeto, setTimeTo] = useState('23:59:59')
  const [monday, setMonday] = useState(true)
  const [tuesday, setTuesday] = useState(true)
  const [wednesday, setWednesday] = useState(true)
  const [thursday, setThursday] = useState(true)
  const [friday, setFriday] = useState(true)
  const [saturday, setSaturday] = useState(true)
  const [sunday, setSunday] = useState(true)
  const [promoGroup, setPromoGroup] = useState('')
  const [promoGroupDesc, setPromoGroupDesc] = useState('')
  const [billValFrom, setBillValFrom] = useState(0)
  const [billValTo, setBillValTo] = useState(0)
  const [datePertiodFrom, setDatePertiodFrom] = useState('0')
  const [datePertiodTo, setDatePertiodTo] = useState('0')
  const [exclusingItems, setExclusiveItems] = useState(true)
  const [loyaltyCustomers, setLoyaltyCustomers] = useState(false)
  const [promoPriority, setPromoPriority] = useState(0)
  const [selectCoupon, setSelectCoupon] = useState(0)
  const [triggerClear, setTriggerClear] = useState(false)
  const [checkComIncItemBun, setCheckComIncItemBun] = useState(false)
  const [sysGenCoupon, setSysGenCoupon] = useState(false)

  const dayNumbers = ['1', '2', '3', '4', '5', '6', '7'];
  const [daysOfWeek, setDaysOfWeek] = useState([
    { name: 'Sunday', state: false },
    { name: 'Monday', state: false },
    { name: 'Tuesday', state: false },
    { name: 'Wednesday', state: false },
    { name: 'Thursday', state: false },
    { name: 'Friday', state: false },
    { name: 'Saturday', state: false },

  ]);

  /*Promotion Coupon Tab*/
  const [couponList, setCouponList] = useState([])
  const [couponFromDate, setCouponFromDate] = useState(todaydate)
  const [couponToDate, setCouponToDate] = useState(todaydate)
  const [couponBillvalueFrom, setCouponBillvalueFrom] = useState(0)
  const [couponBillvalueTo, setCouponBillvalueTo] = useState(0)



  const [loyaltyStatus, setLoyaltyStatus] = useState('M')
  const [birthdayBased, setBirthdayBased] = useState(false)
  const [anniversary, setAnniversary] = useState(false)
  const [ebill, setEbill] = useState(false)
  const [mobileApp, setMobileApp] = useState(false)
  const [minimumPontBalance, setMinimumPontBalance] = useState('0')
  const [PRO_CUSLIMIT, setPRO_CUSLIMIT] = useState(0)
  const [print, setPrint] = useState(false)
  const [status, setStatus] = useState(true)
  const [isCustomer, setIsCustomer] = useState(false)


  const [allCompany, setAllCompany] = useState([])
  const [company, setCompany] = useState("")
  //**  Set Values for Contact Details  Tab (Tab==2) */

  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)


  //Exclutions tab usestates
  const [customerExclude, setCustomerExclude] = useState("")
  const [customerInclude, setCustomerInclude] = useState("")
  const [supplierExclude, setSupplierExclude] = useState("")
  const [supplierInclude, setSupplierInclude] = useState("")
  const [itemBundleExclude, setItemBundleExclude] = useState([])
  const [itemBundleInclude, setItemBundleInclude] = useState([])
  const [groupBundleExclude, setGroupBundleExclude] = useState("")
  const [groupBundleInclude, setGroupBundleInclude] = useState("")
  const [skuCode, setSkuCode] = useState('')
  const [skuBundleCode, setSkuBundleCode] = useState('')
  const [customerbundles, setcustomerbundles] = useState([]);
  const [supplierbundles, setsupplierbundles] = useState([]);
  const [ticketSet, setTicketSet] = useState([])
  const [binList, setBinList] = useState([]);
  const [pricemodeList, setPricemodeList] = useState([])
  const [selectedPricemode, setSelectedPricemode] = useState("")
  const [isPricemodeEnable, setIsPricemodeEnable] = useState([])
  //dropdown usestates


  //Paymode Tab usestates
  const [allpaymodes, setAllpaymodes] = useState([])
  //End Paymode Tab usestates


  //Location Tab useStates
  const [loc, setLoc] = useState([])
  //End location tab useStates


  //Details Tab useStates
  const [dtItemBundle, setDtItemBundle] = useState('')
  const [dtGroupBundle, setDtGroupBundle] = useState('')
  const [dtMinQty, setDtMinQty] = useState('0')
  const [dtMaxQty, setDtMaxQty] = useState('0')
  const [dtIncrementQty, setDtIncrementQty] = useState('0')
  const [dtMinValue, setDtMinValue] = useState('0')
  const [dtMaxValue, setDtMaxValue] = useState('0')
  const [dtIncrementalValue, setDtIncrementalValue] = useState('0')
  const [dtDiscPer, setDtDiscPer] = useState('0')
  const [dtIncrementDescPer, setDtIncrementDescPer] = useState('0')
  const [dtDiscountAmount, setDtDiscountAmount] = useState('0')
  const [dtIncrementalDiscount, setDtIncrementalDiscount] = useState('0')
  const [dtFreeItmBundle, setDtFreeItmBundle] = useState('')
  const [dtFreeIssueQty, setDtFreeIssueQty] = useState('0')
  const [dtFreeIssueIncreQty, setDtFreeIssueIncreQty] = useState('0')
  const [dtTicket, setDtTicket] = useState('0')
  const [dtNoOfTicketIssue, setDtNoOfTicketIssue] = useState('0')
  const [INCTICKQTY, setINCTICKQTY] = useState('0')
  const [VOUVALUE, setVOUVALUE] = useState('0')
  const [VOUQTY, setVOUQTY] = useState('0')
  const [INCVOUQTY, setINCVOUQTY] = useState('0')
  const [POINTS, setPOINTS] = useState('0')
  const [INCPOINTS, setINCPOINTS] = useState('0')
  const [INCROUNDS, setINCROUNDS] = useState('0')
  const [itemBundle, setItemBundle] = useState("")
  const [groupBundle, setGroupBundle] = useState("")
  const [allItemBundles, setAllItemBundles] = useState("")
  const [allItemGroupBundles, setAllItemGroupBundles] = useState("")
  const [showAllFields, setShowAllFields] = useState(false)
  const [freeIssueItem, setFreeIssueItem] = useState("")
  const [ticket, setTicket] = useState("")
  const [ProDetailsTable, setProDetailsTable] = useState("")
  const [companyContribution, setCompanyContribution] = useState(0)
  const [supplierContribution, setSupplierContribution] = useState(0)
  //End Details Tab useStates

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */


  //**Set Active Tab panel */
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    } else {
      setcustomActiveTab(customActiveTab == tab ? tab : "1")
    }
  }


  //**Create list of tab panels */

  //*** User Activity related states*/
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlarge2, setmodal_xlarge2] = useState(false)
  const [modal_xlarge3, setmodal_xlarge3] = useState(false)
  const [modal_xlarge4, setmodal_xlarge4] = useState(false)
  const [modal_xlarge5, setmodal_xlarge5] = useState(false)
  const [modal_xlarge6, setmodal_xlarge6] = useState(false)
  const [modal_xlarge7, setmodal_xlarge7] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [disableGroupCode, setDisableGroupCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  //*** End User activity related staes */

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState('')
  const [addNew, SetaddNew] = useState(true)

  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [menuCode, SetMenuCode] = useState("")


  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  var time = process.env.REACT_APP_ALERTTIMEOUT
  const ApiURL = window.Links.ApiURL //
  //**Get File Details */

  //promotion group related states

  const [outlet, setOutlet] = useState(false)
  const [payAct, setPayAct] = useState(false)
  const [exclAct, setExclAct] = useState(false)
  const [inclAct, setInclAct] = useState(false)
  const [pskubidAct, setPskubidAct] = useState(false)
  const [grpbidAct, setGrpbidAct] = useState(false)
  const [diskperAct, setDiskperAct] = useState(false)
  const [diskamtAct, setDiskamtAct] = useState(false)
  const [fskbidAct, setFskbidAct] = useState(false)
  const [ticketAct, setTicketAct] = useState(false)
  const [ticketValue, setTicketValue] = useState(false)
  const [vouAct, setVouAct] = useState(false)
  const [pointAct, setPointAct] = useState(false)
  const [shwoloyaltyCustomers, setShwoloyaltyCustomers] = useState(false)
  const [setBin, setSetBin] = useState(false)
  const [couponRedemption, setCouponRedemption] = useState(false)
  const [helpUrl, setHelpUrl] = useState("")

  const [newTabList, setNewTabList] = useState(
    [
      {
        text: "General",
        icon: "fas fa-home",
        tabID: "1",
        onClick: () => {
          toggleCustom("1")
        },
      },

    ]
  )

  //import from contexts
  const {
    isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
  } = useContext(Context);
  //import from contexts

  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    const ApiURL = window.Links.ApiURL

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)
    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }

  }, [code])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]

    setcustomerbundles(await getCustomerBundles())
    setsupplierbundles(await getSupplierBundles())
    setAllCompany(await getCompany())
    setAllItemBundles(await SKU())
    setAllItemGroupBundles(await SKUBundle())
    setTicketSet(await getTickets())
    setLoc(await getPromotionLocations(LogUserType))
    const pricemodelist = await getPriceModes()
    setPricemodeList(pricemodelist.data)

    // setAllpaymodes(await getPaymentModes())

    const paymentModeList = await getPaymentModes()

    if (paymentModeList.length > 0) {
      const modifiedPaymentModeList = paymentModeList.map((item, index) => {
        return {
          ...item,
          apply: false,
          pD_PHMin: "0.00",
          pD_PHMax: "0.00",
          pD_PHDiscount: "0.00",
        }
      })

      setAllpaymodes(modifiedPaymentModeList)
    } else {
      setAllpaymodes([])
    }

  }, [])


  const ClearItem = async () => {

    setCode("")
    setName("")
    setDescription("")
    setDateFrom("")
    setDateTo("")
    setMonday(true)
    setTuesday(true)
    setWednesday(true)
    setThursday(true)
    setFriday(true)
    setSaturday(true)
    setSunday(true)
    setTimeFrom('00:00:00')
    setTimeTo('23:59:59')
    setDateFrom(todaydate)
    setDateTo(todaydate)
    setPromoGroup("")
    setBillValFrom(0)
    setBillValTo(0)
    setAnniversary("")
    setEbill("")
    setMobileApp("")
    setMinimumPontBalance("")
    setCouponList([])
    setDaysOfWeek([
      { name: 'Sunday', state: false },
      { name: 'Monday', state: false },
      { name: 'Tuesday', state: false },
      { name: 'Wednesday', state: false },
      { name: 'Thursday', state: false },
      { name: 'Friday', state: false },
      { name: 'Saturday', state: false },
    ])

    setCompany("")
    setLoyaltyStatus("M")
    setBirthdayBased(false)
    setAnniversary(false)
    setEbill(false)
    setMobileApp(false)
    setMinimumPontBalance('0')
    setPRO_CUSLIMIT(0)
    setPrint(false)
    setStatus(true)
    setIsCustomer(false)
    setSkuCode("")
    setSkuBundleCode("")

    setAllpaymodes([])


    setDtItemBundle('')
    setDtGroupBundle('')
    setDtMinQty(0)
    setDtMaxQty(0)
    setDtIncrementQty(0)
    setDtMinValue(0)
    setDtMaxValue(0)
    setDtIncrementalValue(0)
    setDtDiscPer(0)
    setDtIncrementDescPer(0)
    setDtDiscountAmount(0)
    setDtIncrementalDiscount(0)
    setDtFreeItmBundle('')
    setDtFreeIssueQty(0)
    setDtFreeIssueIncreQty(0)
    setDtTicket(0)
    setDtNoOfTicketIssue(0)
    setINCTICKQTY(0)
    setVOUVALUE(0)
    setVOUQTY(0)
    setINCVOUQTY(0)
    setPOINTS(0)
    setINCPOINTS(0)

    setDisabledCode(false)
    setDisabled(false)
    setCrEnable(false)
    SetaddNew(true)
    setErrorMsg('')
    SetDeleteEnable(false)
    setNullCode(false)
    setSearchdisabled(false)
    setReason("Created")
    SetEditEnable(false)
    setSaveEnable(true)
    setPermissionName("")
    setPermissionPassword("")
    setPermissionNameDisable(false)
    setCodeButton(true)
    setINCROUNDS(0)
    setShowAllFields(false)
    setDisableGroupCode(false)
    setExclusiveItems(true)
    setLoyaltyCustomers(false)
    setCouponRedemption(false)
    setSysGenCoupon(false)
    setSelectCoupon(0)
    setCheckComIncItemBun(false)
    setPromoPriority(0)
    setPromoGroupDesc("")
    setDatePertiodFrom(0)
    setDatePertiodTo(0)
    setBinList([])
    setSupplierInclude("")
    setCustomerInclude("")
    setSupplierExclude("")
    setCustomerExclude("")
    setItemBundle("")
    setGroupBundle("")
    setGroupBundleInclude("")
    setGroupBundleExclude("")
    setItemBundleInclude([])
    setItemBundleExclude([])
    setFreeIssueItem("")
    setProDetailsTable([])
    setCompanyContribution(0)
    setSupplierContribution(0)
    setTriggerClear(current => !current)
    setCouponFromDate(todaydate)
    setCouponToDate(todaydate)
    setCouponBillvalueFrom(0)
    setCouponBillvalueTo(0)
    setSelectedPricemode("")
    setIsPricemodeEnable(false)
    setTimeout(() => {
      setNewTabList([
        {
          text: "General",
          icon: "fas fa-home",
          tabID: "1",
          onClick: () => {
            toggleCustom("1")
          },
        },
      ])
    }, 1)
    // setEditCheck(false)
    toggleCustom('1')

    setAllpaymodes(await getPaymentModes())
    setLoc(await getPromotionLocations(LogUserType))
  }

  // model trigger

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_xlarge2() {
    setmodal_xlarge2(!modal_xlarge2)
    removeBodyCss()
  }

  function tog_xlarge3() {
    setmodal_xlarge3(!modal_xlarge3)
    removeBodyCss()
  }
  function tog_xlarge4() {
    setmodal_xlarge4(!modal_xlarge4)
    removeBodyCss()
  }
  function tog_xlarge5() {
    setmodal_xlarge5(!modal_xlarge5)
    removeBodyCss()
  }
  function tog_xlarge6() {
    setmodal_xlarge6(!modal_xlarge6)
    removeBodyCss()
  }
  function tog_xlarge7() {
    setmodal_xlarge7(!modal_xlarge7)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }



  //*** Get user selected row details */
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    getPromotion(row.PRO_CODE)
    setDisabled(true)
    setDisabledCode(true)

    setmodal_xlarge(!modal_xlarge);
    setCrEnable(true)
    setSaveEnable(false)

  }

  const GetSelectRow2 = (e, row, isSelect, rowIndex) => {
    setPromoGroup(row.PG_CODE)
    getPromotionGroup(row.PG_CODE)
    setmodal_xlarge2(!modal_xlarge2);
  }


  const getSKUSelectedRow = (row, isSelect, rowIndex, e) => {
    setSkuCode(row.code)
    setmodal_xlarge3(!modal_xlarge3);
  }

  const getSKUBundleSelectedRow = (row, isSelect, rowIndex, e) => {
    setSkuBundleCode(row.code)
    setmodal_xlarge4(!modal_xlarge4);
  }

  const getSKUGroupSelectedRow = (row, isSelect, rowIndex, e) => {
    setDtItemBundle(row.code)
    setmodal_xlarge5(!modal_xlarge5);
  }

  const getSKUGroupBundleSelectedRow = (row, isSelect, rowIndex, e) => {
    setDtGroupBundle(row.code)
    setmodal_xlarge6(!modal_xlarge6);
  }

  const getSKUFreeSelectedRow = (row, isSelect, rowIndex, e) => {
    setDtFreeItmBundle(row.code)
    setmodal_xlarge7(!modal_xlarge7);
  }


  //Toolbar Fucntions

  //edit button function    
  const handleEdit = e => {

    setDisabled(false)
    setDisabledCode(true)
    setSaveEnable(true)
    SetDeleteEnable(true)
    SetEditEnable(false)
    SetaddNew(false)
  }

  //New button function
  const handleNew = e => {
    //e.preventDefault()
    ClearItem();
    setShow(false)
    setSaveEnable(true)
    SetaddNew(true)
    setCrEnable(false)
    setDisabled(false)
    SetEditEnable(false)
  }


  //save button function
  const handlesave = async () => {

    if (name == '') {
      displayAlertMessage('danger', "Please Enter Promotion Description !")
      toggleCustom('1')
      return;
    }

    if (promoGroup == '') {
      displayAlertMessage('danger', "Please Enter Promotion Group !")
      toggleCustom('1')
      return;
    }

    if (company == '') {
      displayAlertMessage('danger', "Please Selecct Company!")
      toggleCustom('1')
      return;
    }

    if (Number(billValFrom) > Number(billValTo)) {
      displayAlertMessage('danger', "End bill value should be grater than Start value !")
      toggleCustom('1')
      return;
    }

    if (datefrom == '') {
      displayAlertMessage('danger', "Please Select Start Date !")
      toggleCustom('1')
      return;
    }
    if (dateto == '') {
      displayAlertMessage('danger', "Please Select End Date !")
      toggleCustom('1')
      return;
    }
    if (timefrom == '') {
      displayAlertMessage('danger', "Please Select Start Time !")
      toggleCustom('1')
      return;
    }
    if (timeto == '') {
      displayAlertMessage('danger', "Please Select End Time !")
      toggleCustom('1')
      return;
    }

    if (loc.filter(x => x.state == true).length == 0) {
      displayAlertMessage('danger', "Please Select Location !")
      toggleCustom('2')
      return;
    }

    var newCode = ''
    if (addNew == true && nullCode == false) {
      setCode(autoCode)
      newCode = autoCode
    } else {
      newCode = code
    }


    newCode = addNew == true && nullCode == false ? autoCode : code

    var filteredLocations = loc.filter(x => x.state == true)
    var locationGroupArray = []

    filteredLocations.map((item, index) => {
      locationGroupArray.push({
        "PROL_CODE": newCode,
        "PROL_LOCCODE": item.code,
      })
    })

    var selectedDays = []

    daysOfWeek.forEach((item, index) => {
      if (item.state == true) {
        selectedDays.push(index + 1)
      }
    })

    if (selectedDays.length == 0) {
      displayAlertMessage('danger', "Please Select Days !")
      toggleCustom('1')
      return;
    }


    var selectedPaymentModes = []
    var bintable = []

    const selectedPaymodes = allpaymodes.filter(x => x.apply == true)

    if (payAct) {

      if (selectedPaymodes.length == 0) {
        displayAlertMessage('danger', "Please Select Payment Mode !")
        toggleCustom("3")
        return;
      } else if (selectedPaymodes.length > 1) {
        displayAlertMessage('danger', "Please Select Only One Payment Mode !")
        toggleCustom("3")
        return;
      }

      if (parseFloat(selectedPaymodes[0].pD_PHMin) == 0 || selectedPaymodes[0].pD_PHMin == "NaN") {
        displayAlertMessage('danger', "Please Enter Minimum Bill Value !")
        toggleCustom("3")
        return;
      }

      if (parseFloat(selectedPaymodes[0].pD_PHMax) == 0 || selectedPaymodes[0].pD_PHMax == "NaN") {
        displayAlertMessage('danger', "Please Enter Maximum Bill Value !")
        toggleCustom("3")
        return;
      }

      if (parseFloat(selectedPaymodes[0].pD_PHDiscount) == 0 || selectedPaymodes[0].pD_PHDiscount == "NaN") {
        displayAlertMessage('danger', "Please Enter Discount Percentage !")
        toggleCustom("3")
        return;
      }

      selectedPaymodes.forEach((item, index) => {
        selectedPaymentModes.push({
          "PROP_CODE": newCode,
          "PROP_PHCODE": item.pD_PHCODE,
          "PROP_PDCODE": item.pD_CODE,
          "PROP_MIN": parseFloat(item.pD_PHMin),
          "PROP_MAX": parseFloat(item.pD_PHMax),
          "PROP_DISCPER": parseFloat(item.pD_PHDiscount),
        })
      })

      if (selectedPaymentModes.length == 1) {
        binList.map((item, index) => {
          if (item != "") {
            bintable.push({
              "PB_PROMOCODE": newCode,
              "PB_BINHEDCODE": selectedPaymentModes[0].PROP_PHCODE,
              "PB_BINDETCODE": selectedPaymentModes[0].PROP_PDCODE,
              "PB_CARDBIN": String(item),
              "PB_STATUS": true
            })
          }
        })
      }
    }



    let PromotionExclusion = []
    let PromotionInclude = []

    // if (customerExclude != "" || supplierExclude != "" || itemBundleExclude.length > 0 || groupBundleExclude != "") {

    //   if (itemBundleExclude.length > 0) {
    //     itemBundleExclude.forEach((item) => {
    //       if (item != "" || customerExclude != "" || supplierExclude != "" || groupBundleExclude != "") {
    //         PromotionExclusion.push({
    //           "PROE_CODE": newCode,
    //           "PROE_CUSBUNDLEGROUPS": customerExclude,
    //           "PROE_SUPBUNDLEGROUPS": supplierExclude,
    //           "PROE_ITEMBUNDLEGROUPS": item,
    //           "PROE_GROUPBUNDLEGROUPS": groupBundleExclude,
    //         })
    //       }
    //     })
    //   } else {

    //     if (customerExclude != "" || supplierExclude != "" || groupBundleExclude != "") {
    //       PromotionExclusion = [{
    //         "PROE_CODE": newCode,
    //         "PROE_CUSBUNDLEGROUPS": customerExclude,
    //         "PROE_SUPBUNDLEGROUPS": supplierExclude,
    //         "PROE_ITEMBUNDLEGROUPS": "",
    //         "PROE_GROUPBUNDLEGROUPS": groupBundleExclude,
    //       }]
    //     }
    //   }
    // }

    //if the customerExclude or supplierExclude or itemBundleExclude or groupBundleExclude is not empty then push the values to the PromotionExclusion array
    if (customerExclude || supplierExclude || itemBundleExclude.length > 0 || groupBundleExclude) {
      if (itemBundleExclude.length > 0) {
        itemBundleExclude.forEach((item) => {
          if (item || customerExclude || supplierExclude || groupBundleExclude) {
            PromotionExclusion.push({
              "PROE_CODE": newCode,
              "PROE_CUSBUNDLEGROUPS": customerExclude,
              "PROE_SUPBUNDLEGROUPS": supplierExclude,
              "PROE_ITEMBUNDLEGROUPS": item,
              "PROE_GROUPBUNDLEGROUPS": groupBundleExclude,
            });
          }
        });
      } else {
        if (customerExclude || supplierExclude || groupBundleExclude) {
          PromotionExclusion.push({
            "PROE_CODE": newCode,
            "PROE_CUSBUNDLEGROUPS": customerExclude,
            "PROE_SUPBUNDLEGROUPS": supplierExclude,
            "PROE_ITEMBUNDLEGROUPS": "",
            "PROE_GROUPBUNDLEGROUPS": groupBundleExclude,
          });
        }
      }
    }


    // if (customerInclude != "" || supplierInclude != "" || itemBundleInclude.length > 0 || groupBundleInclude != "") {

    //   if (itemBundleInclude.length > 0) {
    //     itemBundleInclude.forEach((item) => {
    //       PromotionInclude.push({
    //         "PROE_CODE": newCode,
    //         "PROE_CUSBUNDLEGROUPS": customerInclude,
    //         "PROE_SUPBUNDLEGROUPS": supplierInclude,
    //         "PROE_ITEMBUNDLEGROUPS": item,
    //         "PROE_GROUPBUNDLEGROUPS": groupBundleInclude,
    //       })
    //     })
    //   } else {

    //     if (customerInclude != "" || supplierInclude != "" || groupBundleInclude != "") {
    //       PromotionInclude = [{
    //         "PROE_CODE": newCode,
    //         "PROE_CUSBUNDLEGROUPS": customerInclude,
    //         "PROE_SUPBUNDLEGROUPS": supplierInclude,
    //         "PROE_ITEMBUNDLEGROUPS": "",
    //         "PROE_GROUPBUNDLEGROUPS": groupBundleInclude,
    //       }]
    //     }

    //   }
    // }


    //if the customerInclude or supplierInclude or itemBundleInclude or groupBundleInclude is not empty then push the values to the PromotionInclude array
    if (customerInclude || supplierInclude || itemBundleInclude.length > 0 || groupBundleInclude) {
      if (itemBundleInclude.length > 0) {
        itemBundleInclude.forEach((item) => {
          if (item || customerInclude || supplierInclude || groupBundleInclude) {
            PromotionInclude.push({
              "PROE_CODE": newCode,
              "PROE_CUSBUNDLEGROUPS": customerInclude,
              "PROE_SUPBUNDLEGROUPS": supplierInclude,
              "PROE_ITEMBUNDLEGROUPS": item,
              "PROE_GROUPBUNDLEGROUPS": groupBundleInclude,
            });
          }
        });
      } else {
        if (customerInclude || supplierInclude || groupBundleInclude) {
          PromotionInclude.push({
            "PROE_CODE": newCode,
            "PROE_CUSBUNDLEGROUPS": customerInclude,
            "PROE_SUPBUNDLEGROUPS": supplierInclude,
            "PROE_ITEMBUNDLEGROUPS": "",
            "PROE_GROUPBUNDLEGROUPS": groupBundleInclude,
          });
        }
      }
    }

    let modifiedCouponList = []

    if (couponRedemption == true) {
      if (selectCoupon == 0) {
        displayAlertMessage('danger', "Please select coupon type!")
        toggleCustom('1')
        return;
      }

      if (selectCoupon == 1) {
        couponList.forEach((item, index) => {
          modifiedCouponList.push({
            "coupon": item.coupon,
            "description": item.description,
            "fromDate": couponFromDate ?? '1900-01-01',
            "toDate": couponToDate ?? '1900-01-01',
            "billValueFrom": parseFloat(couponBillvalueFrom) ?? parseFloat(0),
            "billValueTo": parseFloat(couponBillvalueTo) ?? parseFloat(0),
          })
        })

        if (modifiedCouponList.length == 0) {
          displayAlertMessage('danger', "Please import coupons!")
          toggleCustom('6')
          return;
        }
      }

    }

    //end of get excluded table values
    let newProDetailList = []

    for (let i = 0; i < ProDetailsTable.length; i++) {
      newProDetailList.push({
        "PROD_CODE": newCode,
        "PROD_PSKUBID": ProDetailsTable[i].OfferBun,
        "PROD_GRPBID": groupBundle,
        "PROD_TICKETID": ticketAct ? ticket : '',

        "PROD_MINQTY": parseFloat(ProDetailsTable[i].QtyFrom),
        "PROD_MAXQTY": parseFloat(ProDetailsTable[i].QtyTo),
        "PROD_MINVAL": parseFloat(ProDetailsTable[i].ValueFrom),
        "PROD_MAXVAL": parseFloat(ProDetailsTable[i].ValueTo),
        "PROD_DISCPER": parseFloat(ProDetailsTable[i].DiscPer),
        "PROD_DISCAMT": parseFloat(ProDetailsTable[i].DiscValue),
        "PROD_FREEQTY": parseFloat(ProDetailsTable[i].freeQty),
        "PROD_FREEITEM": String(freeIssueItem),
        "PROD_TICKQTY": parseInt(ProDetailsTable[i].TicketQty),
        "PROD_VOUQTY": parseInt(ProDetailsTable[i].VoucherQty),
        "PROD_VOUVALUE": parseFloat(ProDetailsTable[i].VoucherValue),
        "PROD_POINTS": parseFloat(ProDetailsTable[i].Points),
        "PROD_VALIDQTY": parseFloat(ProDetailsTable[i].validQty),

        "PROD_INCQTY": parseFloat(dtIncrementQty),
        "PROD_INCVAL": parseFloat(dtIncrementalValue),
        "PROD_INCDISCPER": parseFloat(dtIncrementDescPer),
        "PROD_INCDISCAMT": parseFloat(dtIncrementalDiscount),
        "PROD_INCFREEQTY": parseFloat(dtFreeIssueIncreQty),
        "PROD_INCTICKQTY": parseFloat(INCTICKQTY),
        "PROD_INCVOUQTY": parseFloat(INCVOUQTY),
        "PROD_INCPOINTS": parseFloat(INCPOINTS),
        "PROD_INCROUNDS": parseFloat(INCROUNDS),
      })
    }

    if (newCode == "") {
      displayAlertMessage('danger', "Please Enter Promotion Code !")
      toggleCustom('1')
      return;
    }

    const promotionOBJ = {
      "code": newCode,
      "name": name,
      "narration": description,
      "print": print == true ? 1 : 0,
      "group": promoGroup,
      "status": status ? true : false,
      "addNew": addNew,
      "startDate": moment(datefrom).format('YYYY-MM-DD'),
      "endDate": moment(dateto).format('YYYY-MM-DD'),
      "startTime": '1900-01-01T' + (timefrom == "" ? "00:00:00" : timefrom),
      "endTime": '1900-01-01T' + (timeto == "" ? "00:00:00" : timeto),
      "days": parseFloat(selectedDays.join('')), //test
      "minBillNet": parseFloat(billValFrom),
      "maxBillNet": parseFloat(billValTo),
      "company": company,
      "bdayPromo": birthdayBased == true ? 1 : 0,
      "bdayFrom": parseFloat(datePertiodFrom),
      "bdayTo": parseFloat(datePertiodTo),
      "anniversaryPromo": anniversary == true ? 1 : 0,
      "InclusiveItems": exclusingItems == true ? 1 : 0,
      "Priority": parseInt(promoPriority),
      "LoyalCustomers": loyaltyCustomers == true ? 1 : 0,
      "CustomerLimit": parseFloat(PRO_CUSLIMIT),
      "CouponType": parseInt(couponRedemption == false ? 0 : selectCoupon),
      "CouponList": modifiedCouponList,
      "menuCode": menuCode,
      "loggedCompany": LogCompanyCode,
      "loggedLocation": LocationCode,
      "reason": Reason,
      "createdBy": LogUserType,
      "PromotionDetails": newProDetailList,
      "PromotionPayTypes": selectedPaymentModes,
      "PromotionLoca": locationGroupArray,
      "PromotionExclusion": PromotionExclusion,
      "PromotionIncludes": PromotionInclude,
      "RPromotionBincodes": bintable,
      "CheckComIncItemBun": checkComIncItemBun,
      "SysGenCoupon": sysGenCoupon,
      "PriceMode": selectedPricemode,
      "companyContribution": parseFloat(companyContribution),
      "supplierContribution": parseFloat(supplierContribution),

    }
    debugger;

    SetLoadingAlert(true)
    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }

    /** Promotion save function*/
    const result = await savePromotion(promotionOBJ)

    SetLoadingAlert(false)

    if (result.success) {
      displayAlertMessage('success', result.message)
      ClearItem()
    } else {
      if (result.message == "Code Already Exsist!") {
        setCodeButton(false)
      }
      displayAlertMessage('danger', result.message)
    }

  }



  /*********Delete button function */
  const handleDelete = () => {

  }
  //*********Delete button function end */

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {

    var autoCodeRes = await fetchAutoCode(menuCode)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
      setCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }

  }

  //**Permission Check */
  const permission = (operation) => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                displayAlertMessage('danger', `This user don't have permisiion to ${addNew == true ? "save " : " update "} !`)
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })

  }

  async function getPromotion(searchCode) {

    if (searchCode == "") {
      return
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    let dt;
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    await fetch(`${ApiURL}promotion/search/${searchCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    }).then(Response => Response.json())
      .then(responseData => {
        SetLoadingAlert(false)

        if (responseData.success == true) {

          dt = responseData.data[0]

          setCode(dt.code)
          setName(dt.name)
          setDescription(dt.narration)
          setDateFrom(dt.startDate.slice(0, 10))
          setDateTo(dt.endDate.slice(0, 10))

          var day = String(dt.days)

          let currentDays = [...daysOfWeek];
          dayNumbers.forEach((number, index) => {
            if (day.includes(number)) {
              currentDays[index].state = true;
            }
          });

          setSaveEnable(false)
          SetEditEnable(true)
          SetaddNew(false)
          setTimeFrom(dt.startTime.slice(11, 16))
          setTimeTo(dt.endTime.slice(11, 16))
          setPromoGroup(dt.group)
          getPromotionGroup(dt.group)
          setBillValFrom(parseFloat(dt.minBillNet).toFixed(2))
          setBillValTo(parseFloat(dt.maxBillNet).toFixed(2))
          setAnniversary(dt.anniversaryPromo)
          setEbill(dt.ebillPromo)
          setMobileApp(dt.appUserPromo)
          setMinimumPontBalance(parseFloat(dt.minPointBal).toFixed(2))
          setLoyaltyStatus(dt.gender)
          setPRO_CUSLIMIT(dt.cusLimit)
          setBirthdayBased(dt.bdayPromo)
          setPrint(dt.print)
          setStatus(dt.status)
          setIsCustomer(dt.customerRequired)
          setDatePertiodFrom(dt.bdayFrom)
          setDatePertiodTo(dt.bdayTo)
          setExclusiveItems(dt.exclusingItems)
          setLoyaltyCustomers(dt.loyalCustomers)
          setPromoPriority(dt.priority)
          setSelectCoupon(dt.couponType)
          setCouponList(dt.promoCoupons)
          setCheckComIncItemBun(dt.checkComIncItemBun)
          setSysGenCoupon(dt.sysGenCoupon)
          setSelectedPricemode(dt.priceMode)
          setCompanyContribution(dt.companyContribution)
          setSupplierContribution(dt.supplierContribution)


          if (dt.promoCoupons.length > 0) {
            setCouponFromDate(dt.promoCoupons[0].fromDate.slice(0, 10))
            setCouponToDate(dt.promoCoupons[0].toDate.slice(0, 10))
            setCouponBillvalueFrom(dt.promoCoupons[0].billValueFrom)
            setCouponBillvalueTo(dt.promoCoupons[0].billValueTo)
          }

          var newbins = []
          dt.rPromotionBin.map(item => {
            newbins.push(item.pB_CARDBIN)
          })

          setBinList(newbins)

          var newallCompany = []
          var newallPaymodes = []
          var includeItems = []
          var excludeItems = []

          var company = dt.company == "" ? [] : dt.company.split(',')
          setCompany(dt.company)
          var newpromotionExclusion = dt.promotionExclusion[0] == undefined ? [] : dt.promotionExclusion[0]
          var newpromotionIncludes = dt.promotionIncludes[0] == undefined ? [] : dt.promotionIncludes[0]
          var promotionDetail = dt.promotionDetails[0]

          setSupplierInclude(newpromotionIncludes.proE_SUPBUNDLEGROUPS)
          setCustomerInclude(newpromotionIncludes.proE_CUSBUNDLEGROUPS)
          setSupplierExclude(newpromotionExclusion.proE_SUPBUNDLEGROUPS)
          setCustomerExclude(newpromotionExclusion.proE_CUSBUNDLEGROUPS)


          setGroupBundleExclude(newpromotionExclusion.proE_GROUPBUNDLEGROUPS)
          setGroupBundleInclude(newpromotionIncludes.proE_GROUPBUNDLEGROUPS)
          //setItemBundleExclude(newpromotionExclusion.proE_ITEMBUNDLEGROUPS)
          // setItemBundleInclude(newpromotionIncludes.proE_ITEMBUNDLEGROUPS)
          dt.promotionExclusion.map((item, index) => {
            excludeItems.push(item.proE_ITEMBUNDLEGROUPS)
          })

          dt.promotionIncludes.map((item, index) => {
            includeItems.push(item.proE_ITEMBUNDLEGROUPS)
          })

          setItemBundleExclude(excludeItems)
          setItemBundleInclude(includeItems)


          var newList = []

          if (dt.promotionDetails.length > 0) {

            setItemBundle(promotionDetail.proD_PSKUBID)
            setGroupBundle(promotionDetail.proD_GRPBID)
            setTicket(promotionDetail.proD_TICKETID)
            setFreeIssueItem(promotionDetail.proD_FREEITEM)

            dt.promotionDetails.map((item, index) => {
              newList.push({
                "id": index + 1,
                "QtyFrom": item.proD_MINQTY,
                "QtyTo": item.proD_MAXQTY,
                "ValueFrom": parseFloat(item.proD_MINVAL).toFixed(2),
                "ValueTo": parseFloat(item.proD_MAXVAL).toFixed(2),
                "DiscPer": parseFloat(item.proD_DISCPER).toFixed(2),
                "DiscValue": parseFloat(item.proD_DISCAMT).toFixed(2),
                "freeQty": item.proD_FREEQTY,
                "TicketQty": item.proD_TICKQTY,
                "VoucherQty": item.proD_VOUQTY,
                "VoucherValue": item.proD_VOUVALUE,
                "Points": item.proD_POINTS,
                "validQty": item.proD_VALIDQTY,
                "OfferBun": item.proD_PSKUBID,
              })
            })


            setDtItemBundle(promotionDetail.proD_PSKUBID)
            setDtGroupBundle(promotionDetail.proD_GRPBID)

          }


          company.map(item => {
            allCompany.find((x) => {
              if (x.value == item) {
                newallCompany = newallCompany.concat(x)
              }
            })
          }
          )

          var currentLocations = loc

          currentLocations.map((item, index) => {
            var locationOBJ = dt.promotionLoca.find((x) => { return x.proL_LOCCODE == item.code })
            if (locationOBJ != undefined) {
              currentLocations[index].state = true
            } else {
              currentLocations[index].state = false
            }
          })

          setLoc(currentLocations)


          allpaymodes.map(item => {
            var added = false
            dt.promotionPayTypes.find((x) => {
              if (item.pD_CODE == x.proP_PDCODE && item.pD_PHCODE == x.proP_PHCODE) {
                added = true
                newallPaymodes = newallPaymodes.concat({
                  "pD_CODE": item.pD_CODE,
                  "pD_DESC": item.pD_DESC,
                  "pH_DESC": item.pH_DESC,
                  "pD_PHCODE": item.pD_PHCODE,
                  "pD_PHMin": parseFloat(x.proP_MIN).toFixed(2),
                  "pD_PHMax": parseFloat(x.proP_MAX).toFixed(2),
                  "pD_PHDiscount": parseFloat(x.proP_DISCPER).toFixed(2),
                  "apply": true
                })
              }
            })

            if (added == false) {
              newallPaymodes = newallPaymodes.concat({
                "pD_CODE": item.pD_CODE,
                "pD_DESC": item.pD_DESC,
                "pH_DESC": item.pH_DESC,
                "pD_PHCODE": item.pD_PHCODE,
                "pD_PHMin": parseFloat(0).toFixed(2),
                "pD_PHMax": parseFloat(0).toFixed(2),
                "pD_PHDiscount": parseFloat(0).toFixed(2),
                "apply": false
              })
            }

          }
          )



          setProDetailsTable(newList)

          setCrBy(dt.createdBy)
          setMdBy(dt.modifiedBy)
          setCrDate(dt.createdDate)
          setMdDate(dt.modifiedDate == "1900-01-01T00:00:00" ? "" : dt.modifiedDate)
          setCrEnable(true)

          setSkuCode(newpromotionExclusion.proE_SKUBID)
          setSkuBundleCode(newpromotionExclusion.proE_GRPBID)

          setDisabled(true)
          setDisabledCode(true)
          setDisableGroupCode(true)

          setAllpaymodes(newallPaymodes)




        } else if (responseData.success == false) {

          if (nullCode == false) {
            ClearItem()
            displayAlertMessage('success', "Record Not Found !")
          }
        }
      }).catch(err => {
        console.log(err)
        SetLoadingAlert(false)
      }).catch(err => {
        console.log(false)
      })

  }


  async function getPromotionGroup(searchCode) {

    const result = await PromotionGroupDetailsGetData(searchCode);

    if (result.success) {
      setPromoGroupDesc(result.data.description)
      setOutlet(result.data.outlet == "1" ? true : false)
      setPayAct(result.data.payement == "1" ? true : false)
      setExclAct(result.data.exclusion == "1" ? true : false)
      setInclAct(result.data.includes == "1" ? true : false)
      setPskubidAct(result.data.skuBundle == "1" ? true : false)
      setGrpbidAct(result.data.groupBundle == "1" ? true : false)
      setDiskperAct(result.data.discountPre == "1" ? true : false)
      setDiskamtAct(result.data.discountAmo == "1" ? true : false)
      setFskbidAct(result.data.free == "1" ? true : false)
      setTicketAct(result.data.ticket == "1" ? true : false)
      setTicketValue(result.data.ticketValue == "1" ? true : false)
      setVouAct(result.data.voucher == "1" ? true : false)
      setPointAct(result.data.point == "1" ? true : false)
      setSetBin(result.data.intCard == "1" ? true : false)
      setShwoloyaltyCustomers(result.data.cusSpecific == "1" ? true : false)
      setCouponRedemption(result.data.intCouponRedemption == "1" ? true : false)
      setIsPricemodeEnable(result.data.intPricemode == "1" ? true : false)

      setDisableGroupCode(true)
      setShowAllFields(true)

      var newlist = []

      newlist.push(
        {
          text: "General",
          icon: "fas fa-home",
          tabID: "1",
          onClick: () => {
            toggleCustom("1")
          },
        },
        {
          text: "Locations",
          icon: "far fa-user",
          tabID: "2",
          onClick: () => {
            toggleCustom("2")
          },
        },
        {
          text: "Details",
          icon: "far fa-user",
          tabID: "5",
          onClick: () => {
            toggleCustom("5")
          },
        },
      )

      if (result.data.payement == "1") {
        newlist.push({
          text: "Payment Mode",
          icon: "far fa-user",
          tabID: "3",
          onClick: () => {
            toggleCustom("3")
          },
        })
      }

      if (result.data.exclusion == "1" || result.data.includes == "1" || result.data.cusSpecific == "1") {
        newlist.push({
          text: "Include/Exclude",
          icon: "far fa-user",
          tabID: "4",
          onClick: () => {
            toggleCustom("4")
          },
        })
      }

      const orderedArray = newlist.sort((a, b) => a.tabID - b.tabID); //reorder tabs
      setNewTabList(orderedArray)

    } else {
      displayAlertMessage('danger', "Invalid Promotion group Code !")
      setPromoGroup("")
    }

  }


  //Function for displaying Alert Messages.
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  function HandleDaysOfWeek(index, value) {

    let newDays = [...daysOfWeek]
    newDays[index].state = value
    setDaysOfWeek(newDays)

  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)

              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                history.push('/dashboard')
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {
                SetPayHedLinkDetail(!blPayHedLinkDetail)
                setarRow([])
              } else if (AlertConfirmOption == 7) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 6) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              }
            }}
            onCancel={() => {
              setsweetAlertShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 6) {
                permission("Delete")
              } else if (AlertConfirmOption == 7) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?");
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?");
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                      setShow(false)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={editEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?");
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to Print ?");
                      setAlertConfirmOption(7)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to Delete ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                      // alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?");
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <p />
                  <DPNavBar buttons={newTabList} activeStatus={customActiveTab} />
                  <TabContent activeTab={customActiveTab} className="p-3 text">
                    {show ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        <small>{ErrorMsg}</small>
                      </Alert>
                    ) : null}
                    <TabPane tabId="1">
                      <PromotionMasterGenContent
                        autoCode={autoCode}
                        setCompany={e => { setCompany(e["value"]) }}
                        company={company}

                        minimumPontBalance={minimumPontBalance}
                        setMinimumPontBalance={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setMinimumPontBalance(0)
                          } else {
                            setMinimumPontBalance(val)
                          }
                        }}
                        setMinimumPontBalanceOnblur={(e) => {
                          if (e.target.value == "") {
                            setMinimumPontBalance(0)
                          } else {
                            setMinimumPontBalance(parseFloat(e.target.value, 10).toFixed(2))
                          }
                        }}
                        mobileApp={mobileApp}
                        setMobileApp={(e) => {
                          setMobileApp(!mobileApp)
                        }}
                        ebill={ebill}
                        setEbill={(e) => {
                          setEbill(!ebill)
                        }}
                        anniversary={anniversary}
                        setAnniversary={(e) => {
                          setAnniversary(!anniversary)
                        }}
                        birthdayBased={birthdayBased}
                        setBirthdayBased={(e) => {
                          setBirthdayBased(!birthdayBased)

                          if (birthdayBased) {
                            setDatePertiodTo(0)
                            setDatePertiodFrom(0)
                          }

                        }}
                        loyaltyStatus={loyaltyStatus}
                        setLoyaltyStatus={(e) => {
                          setLoyaltyStatus(e.target.value)
                        }}
                        billValTo={billValTo}
                        setBillValTo={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setBillValTo(0)
                          } else {
                            setBillValTo(val)
                          }
                        }}
                        setBillValToOnblur={(e) => {
                          if (e.target.value == "") {
                            setBillValTo(parseFloat(0))
                          } else {
                            setBillValTo(DecimalValidation(e.target.value, 0, true, 2))
                          }

                        }}

                        billValFrom={billValFrom}
                        setBillValFrom={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setBillValFrom(0)
                          } else {
                            setBillValFrom(val)
                          }
                        }}
                        setBillValFromOnblur={(e) => {
                          if (e.target.value == "") {
                            setBillValFrom(parseFloat(0))
                          } else {
                            setBillValFrom(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}
                        promoGroup={promoGroup}
                        setPromoGroup={(e) => {
                          let val = Text(e.target, 10, true, false, "any", true)
                          setPromoGroup(val)
                        }}

                        sunday={sunday}
                        setSunday={(e) => {
                          setSunday(!sunday)
                        }}
                        saturday={saturday}
                        setSaturday={(e) => {
                          setSaturday(!saturday)
                        }}
                        friday={friday}
                        setFriday={(e) => {
                          setFriday(!friday)
                        }}
                        thursday={thursday}
                        setThursday={(e) => {
                          setThursday(!thursday)
                        }}
                        wednesday={wednesday}
                        setWednesday={(e) => {
                          setWednesday(!wednesday)
                        }}

                        tuesday={tuesday}
                        setTuesday={(e) => {
                          setTuesday(!tuesday)
                        }}
                        monday={monday}
                        setMonday={(e) => {
                          setMonday(!monday)
                        }}
                        timeto={timeto}
                        setTimeto={(e) => {
                          setTimeTo(e.target.value)
                        }}
                        setTimetoOnblur={(e) => {
                          if (timefrom == "") {
                            setAlertMsg("Please Select Start Time")
                            setAlertColor('danger')
                            setShow(true)
                            setTimeTo('')
                          } else if (timefrom > e.target.value) {
                            setAlertMsg("End Time should be greater than Start Time")
                            setAlertColor('danger')
                            setShow(true)
                            setTimeTo('')
                          } else {
                            setTimeTo(e.target.value)
                          }

                          setTimeout(() => {
                            setShow(false)
                          }, 3000)
                        }}
                        timefrom={timefrom}
                        setTimefrom={(e) => {
                          setTimeFrom(e.target.value)
                        }}
                        setTimefromOnblur={(e) => {
                          if (timeto == "") {
                            setTimeFrom(e.target.value)
                          } else if (timeto < e.target.value) {
                            setAlertMsg("Start Time should be less than End Time")
                            setAlertColor('danger')
                            setShow(true)
                            setTimeFrom('')
                          } else {
                            setTimeFrom(e.target.value)
                          }

                          setTimeout(() => {
                            setShow(false)
                          }, 3000)
                        }}
                        dateto={dateto}
                        setDateto={(e) => {
                          setDateTo(e.target.value)
                        }}
                        setDatetoOnblur={(e) => {
                          if (datefrom == "") {
                            setAlertMsg("Please Select Start Date")
                            setAlertColor('danger')
                            setShow(true)
                            setDateTo('')
                          } else if (datefrom > e.target.value) {
                            setAlertMsg("End Date should be greater than Start Date")
                            setAlertColor('danger')
                            setShow(true)
                            setDateTo('')
                          } else {
                            setDateTo(e.target.value)
                          }

                          setTimeout(() => {
                            setShow(false)
                          }, 3000)
                        }}
                        datefrom={datefrom}
                        setDatefrom={(e) => {
                          setDateFrom(e.target.value)
                        }}
                        setDatefromOnblur={(e) => {
                          if (dateto == "") {
                            setDateFrom(e.target.value)
                          } else if (dateto < e.target.value) {
                            setAlertMsg("Start Date should be less than End Date")
                            setAlertColor('danger')
                            setShow(true)
                            setDateFrom('')
                          } else {
                            setDateFrom(e.target.value)
                          }

                          setTimeout(() => {
                            setShow(false)
                          }, 3000)
                        }}
                        description={description}
                        setDescription={(e) => {
                          let val = Text(e.target, 1000, true, true, "any", true)
                          setDescription(val)
                        }}
                        name={name}
                        setName={(e) => {
                          let val = Text(e.target, 50, true, true, "any", true)
                          setName(val)
                        }}

                        code={code}
                        setCode={(e) => {
                          let val = Text(
                            e.target,
                            10,
                            true,
                            false,
                            "upper",
                            false
                          )
                          setCode(val)
                        }}
                        codeOnblur={(e) => {
                          if (e.target.value != '') {
                            getPromotion(e.target.value)
                          }
                        }}
                        print={print}
                        setPrint={(e) => {
                          setPrint(!print)
                        }}
                        status={status}
                        setStatus={(e) => {
                          setStatus(!status)
                        }}
                        isCustomer={isCustomer}
                        setIsCustomer={(e) => {
                          setIsCustomer(!isCustomer)
                        }}

                        codeButton={codeButton}
                        onButtonClick={e => {
                          AutoGenerateCode()
                          setCodeButton(true)
                        }}
                        tog_xlarge={tog_xlarge}
                        modal_xlarge={modal_xlarge}
                        menuName={menuName}
                        tog_xlarge2={tog_xlarge2}
                        modal_xlarge2={modal_xlarge2}

                        allCompany={allCompany}

                        disabled={disabled}
                        disabledCode={disabledCode}
                        GetSelectRow={GetSelectRow}
                        GetSelectRow2={GetSelectRow2}
                        setPromoGroupOnBlur={(e) => {
                          if (promoGroup != '') {
                            getPromotionGroup(e.target.value)
                          }
                        }}
                        setDatePertiodFrom={(e) => {
                          let val = Numeric(e.target, 8, 0, false)
                          if (val == "") {
                            setDatePertiodFrom(0)
                          } else {
                            setDatePertiodFrom(parseFloat(val, 10))
                          }
                        }}
                        setDatePertiodTo={(e) => {
                          let val = Numeric(e.target, 8, 0, false)
                          if (val == "") {
                            setDatePertiodTo(0)
                          } else {
                            setDatePertiodTo(parseFloat(val, 10))
                          }
                        }}
                        datePertiodFrom={datePertiodFrom}
                        datePertiodTo={datePertiodTo}
                        menuCode={menuCode}
                        showAllFields={showAllFields}
                        disableGroupCode={disableGroupCode}
                        ticketAct={ticketAct}
                        setExclusiveItems={(e) => {
                          setExclusiveItems(!exclusingItems)
                        }}
                        exclusingItems={exclusingItems}
                        setLoyaltyCustomers={(e) => {
                          setLoyaltyCustomers(!loyaltyCustomers)
                        }}
                        loyaltyCustomers={loyaltyCustomers}
                        setPromoPriority={(e) => {
                          var val1 = Numeric(e.target, 4, 0, false)
                          if (val1 == "") {
                            setPromoPriority(0)
                          }
                          else {
                            setPromoPriority(val1)
                          }
                        }}
                        promoPriority={promoPriority}
                        setPromoPriorityOnBlur={(e) => {
                          if (e.target.value == "") {
                            setPromoPriority(0)
                          }
                          else {
                            setPromoPriority(parseInt(e.target.value, 10))
                          }
                        }
                        }
                        shwoloyaltyCustomers={shwoloyaltyCustomers}
                        promoGroupDesc={promoGroupDesc}
                        setPRO_CUSLIMIT={(e) => {
                          var val1 = Numeric(e.target, 8, 0, false)
                          if (val1 == "") {
                            setPRO_CUSLIMIT(0)
                          }
                          else {
                            setPRO_CUSLIMIT(val1)
                          }

                        }}
                        PRO_CUSLIMIT={PRO_CUSLIMIT}
                        setPRO_CUSLIMITOnBlur={(e) => {
                          if (e.target.value == "") {
                            setPRO_CUSLIMIT(0)
                          }
                          else {
                            setPRO_CUSLIMIT(parseInt(e.target.value, 10))
                          }
                        }}
                        couponRedemption={couponRedemption}
                        selectCoupon={selectCoupon}
                        setSelectCoupon={(e) => {
                          setSelectCoupon(e["value"])

                          const isValueOne = parseInt(e["value"]) === 1;
                          const updatedList = isValueOne
                            ? [
                              ...newTabList.filter((item) => item.tabID !== "6"),
                              {
                                text: "Coupons",
                                icon: "far fa-user",
                                tabID: "6",
                                onClick: () => {
                                  toggleCustom("6");
                                },
                              },
                            ]
                            : newTabList.filter((item) => item.tabID !== "6");

                          setNewTabList(updatedList);


                        }}
                        inclAct={inclAct}
                        checkComIncItemBun={checkComIncItemBun}
                        sysGenCoupon={sysGenCoupon}
                        sysGenCouponOnchange={(e) => {
                          setSysGenCoupon(e)
                        }}
                        daysOfWeek={daysOfWeek}
                        HandleDaysOfWeek={HandleDaysOfWeek}
                        pricemodeList={pricemodeList}
                        setSelectedPricemode={(e) => {
                          setSelectedPricemode(e["value"])
                        }}
                        selectedPricemode={selectedPricemode}
                        isPricemodeEnable={isPricemodeEnable}
                        companyContribution={companyContribution}
                        companyContributionOnchange={(e) => {
                          var val1 = Numeric(e.target, 8, 2, false)
                          setCompanyContribution(val1)
                        }}
                        companyContributionOnblur={(e) => {

                          const value = DecimalValidation(e.target.value, 0, true, 2)

                          if (value > 100) {
                            displayAlertMessage('danger', "Company Contribution should not be greater than 100%")
                            setCompanyContribution(0)
                          } else if (value < 0) {
                            displayAlertMessage('danger', "Company Contribution should not be less than 0%")
                            setCompanyContribution(0)
                          } else {
                            setCompanyContribution(value)
                          }

                        }}
                        supplierContribution={supplierContribution}
                        supplierContributionOnchange={(e) => {
                          var val1 = Numeric(e.target, 8, 2, false)
                          setSupplierContribution(val1)
                        }}
                        supplierContributionOnblur={(e) => {

                          const value = DecimalValidation(e.target.value, 0, true, 2)

                          if (value > 100) {

                            displayAlertMessage('danger', "Supplier Contribution should not be greater than 100%")
                            setSupplierContribution(0)
                          } else if (value < 0) {
                            displayAlertMessage('danger', "Supplier Contribution should not be less than 0%")
                            setSupplierContribution(0)
                          }
                          else {
                            setSupplierContribution(value)
                          }


                        }}
                      />

                    </TabPane>
                    <TabPane tabId="2">
                      <PromotionLocationContent
                        loc={loc}
                        setLoc={setLoc}
                        disabled={disabled}
                        disabledCode={disabledCode}
                        showAllFields={showAllFields}
                        triggerClear={triggerClear}
                      />

                    </TabPane>
                    <TabPane tabId="3">

                      <PromotionPaymentModeContent
                        allpaymodes={allpaymodes}
                        setAllpaymodes={setAllpaymodes}
                        disabled={disabled}
                        disabledCode={disabledCode}
                        showAllFields={showAllFields}
                        payAct={payAct}
                        setBinList={setBinList}
                        binList={binList}
                        setBin={setBin}
                      />

                    </TabPane>
                    <TabPane tabId="4">

                      <PromotionExcludeInclude
                        setSupplierInclude={e => {
                          setSupplierInclude(e["value"])
                        }}
                        setSupplierExclude={e => { setSupplierExclude(e["value"]) }}
                        setCustomerInclude={e => { setCustomerInclude(e["value"]) }}
                        setCustomerExclude={e => { setCustomerExclude(e["value"]) }}
                        supplierInclude={supplierInclude}
                        supplierExclude={supplierExclude}
                        customerInclude={customerInclude}
                        customerExclude={customerExclude}
                        customerbundles={customerbundles}
                        supplierbundles={supplierbundles}
                        itemBundleExclude={itemBundleExclude}
                        setItemBundleExclude={selectedGroup => {
                          setItemBundleExclude(selectedGroup);
                        }}
                        itemBundleInclude={itemBundleInclude}
                        setItemBundleInclude={selectedGroup => {
                          setItemBundleInclude(selectedGroup)

                          if (selectedGroup.length > 1) {
                            setCheckComIncItemBun(true)
                          } else {
                            setCheckComIncItemBun(false)
                          }

                        }}
                        groupBundleExclude={groupBundleExclude}
                        setGroupBundleExclude={e => { setGroupBundleExclude(e["value"]) }}
                        groupBundleInclude={groupBundleInclude}
                        setGroupBundleInclude={e => { setGroupBundleInclude(e["value"]) }}
                        allSkubundles={allItemBundles}
                        allSKUGrpBundles={allItemGroupBundles}


                        disabled={disabled}
                        showAllFields={showAllFields}
                        exclAct={exclAct}
                        inclAct={inclAct}
                        shwoloyaltyCustomers={shwoloyaltyCustomers}
                      />

                    </TabPane>
                    <TabPane tabId="5">
                      <PromotionDetailsContent
                        dtItemBundle={dtItemBundle}
                        SetdtItemBundle={(e) => {
                          let val = Text(e.target, 10, true, false, "any", true)
                          setDtItemBundle(val)
                        }}
                        dtItemBundleOnblue={setDtItemBundle}
                        dtGroupBundle={dtGroupBundle}
                        SetdtGroupBundle={(e) => {
                          let val = Text(e.target, 10, true, false, "any", true)
                          setDtGroupBundle(val)
                        }}
                        dtGroupBundleOnblue={setDtGroupBundle}
                        dtMinQty={dtMinQty}
                        SetdtMinQty={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtMinQty(0)
                          } else {
                            setDtMinQty(val)
                          }

                        }}
                        SetdtMinQtyOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtMinQty(0)
                          } else {
                            setDtMinQty(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}
                        dtMaxQty={dtMaxQty}
                        SetdtMaxQty={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtMaxQty(0)
                          } else {
                            setDtMaxQty(val)
                          }
                        }}
                        SetdtMaxQtyOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtMaxQty(0)
                          } else {
                            setDtMaxQty(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}
                        dtIncrementQty={dtIncrementQty}
                        SetdtIncrementQty={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtIncrementQty(0)
                          } else {
                            setDtIncrementQty(val)
                          }
                        }}
                        SetdtIncrementQtyOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtIncrementQty(0)
                          } else {
                            setDtIncrementQty(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}
                        dtDiscPer={dtDiscPer}
                        SetdtDiscPer={(e) => {
                          let val = Numeric(e.target, 5, 2, false)
                          if (val == "") {
                            setDtDiscPer(0)
                          } else {
                            setDtDiscPer(val)
                          }
                        }}
                        SetdtDiscPerOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtDiscPer(0)
                          } else {
                            if (parseFloat(e.target.value) > 100) {
                              setDtDiscPer(0)
                            } else {
                              setDtDiscPer(DecimalValidation(e.target.value, 0))
                            }
                          }
                        }}
                        dtIncrementDescPer={dtIncrementDescPer}
                        SetdtIncrementDescPer={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtIncrementDescPer(0)
                          } else {
                            setDtIncrementDescPer(val)
                          }
                        }}
                        SetdtIncrementDescPerOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtIncrementDescPer(0)
                          } else {
                            if (parseFloat(e.target.value) > 100) {
                              setDtIncrementDescPer(0)
                            } else {
                              setDtIncrementDescPer(DecimalValidation(e.target.value, 0))
                            }
                          }
                        }}
                        dtFreeItmBundle={dtFreeItmBundle}
                        SetdtFreeItmBundle={(e) => {
                          let val = Text(e.target, 10, true, false, "any", true)
                          setDtFreeItmBundle(val)
                        }}

                        dtFreeItmBundleOnblue={setDtFreeItmBundle}
                        dtFreeIssueQty={dtFreeIssueQty}
                        SetdtFreeIssueQty={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtFreeIssueQty(0)
                          } else {
                            setDtFreeIssueQty(val)
                          }
                        }}
                        SetdtFreeIssueQtyOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtFreeIssueQty(0)
                          } else {
                            setDtFreeIssueQty(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}

                        dtFreeIssueIncreQty={dtFreeIssueIncreQty}
                        SetdtFreeIssueIncreQty={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtFreeIssueIncreQty(0)
                          } else {
                            setDtFreeIssueIncreQty(val)
                          }
                        }}
                        SetdtFreeIssueIncreQtyOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtFreeIssueIncreQty(0)
                          } else {
                            setDtFreeIssueIncreQty(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}
                        dtTicket={dtTicket}
                        SetdtTicket={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtTicket(0)
                          } else {
                            setDtTicket(val)
                          }
                        }}
                        SetdtTicketOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtTicket(0)
                          } else {
                            setDtTicket(parseInt(e.target.value, 10))
                          }
                        }}
                        dtNoOfTicketIssue={dtNoOfTicketIssue}
                        SetdtNoOfTicketIssue={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtNoOfTicketIssue(0)
                          } else {
                            setDtNoOfTicketIssue(val)
                          }
                        }}
                        SetdtNoOfTicketIssueOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtNoOfTicketIssue(0)
                          } else {
                            setDtNoOfTicketIssue(parseInt(e.target.value, 10))
                          }
                        }}
                        dtMinValue={dtMinValue}
                        SetdtMinValue={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtMinValue(0)
                          } else {
                            setDtMinValue(val)
                          }
                        }}
                        SetdtMinValueOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtMinValue(0)
                          } else {
                            setDtMinValue(DecimalValidation(e.target.value, 0))
                          }
                        }}
                        dtMaxValue={dtMaxValue}
                        SetdtMaxValue={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtMaxValue(0)
                          } else {
                            setDtMaxValue(val)
                          }
                        }}
                        SetdtMaxValueOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtMaxValue(0)
                          } else {
                            setDtMaxValue(DecimalValidation(e.target.value, 0))
                          }
                        }}

                        dtIncrementalValue={dtIncrementalValue}
                        SetdtIncrementalValue={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtIncrementalValue(0)
                          } else {
                            setDtIncrementalValue(val)
                          }
                        }}
                        SetdtIncrementalValueOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtIncrementalValue(0)
                          } else {
                            setDtIncrementalValue(DecimalValidation(e.target.value, 0))
                          }
                        }}
                        dtDiscountAmount={dtDiscountAmount}
                        SetdtDiscountAmount={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtDiscountAmount(0)
                          } else {
                            setDtDiscountAmount(val)
                          }
                        }}
                        SetdtDiscountAmountOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtDiscountAmount(0)
                          } else {
                            setDtDiscountAmount(DecimalValidation(e.target.value, 0, true, 2))
                          }
                        }}
                        dtIncrementalDiscount={dtIncrementalDiscount}
                        SetdtIncrementalDiscount={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setDtIncrementalDiscount(0)
                          } else {
                            setDtIncrementalDiscount(val)
                          }
                        }}
                        SetdtIncrementalDiscountOnBlur={(e) => {
                          if (e.target.value == "") {
                            setDtIncrementalDiscount(0)
                          } else {
                            setDtIncrementalDiscount(parseInt(e.target.value, 10))
                          }
                        }}
                        tog_xlarge5={tog_xlarge5}
                        modal_xlarge5={modal_xlarge5}
                        tog_xlarge6={tog_xlarge6}
                        modal_xlarge6={modal_xlarge6}
                        tog_xlarge7={tog_xlarge7}
                        modal_xlarge7={modal_xlarge7}
                        getSKUGroupSelectedRow={getSKUGroupSelectedRow}
                        getSKUGroupBundleSelectedRow={getSKUGroupBundleSelectedRow}
                        getSKUFreeSelectedRow={getSKUFreeSelectedRow}
                        setAlertMsg={setAlertMsg}
                        setAlertColor={setAlertColor}
                        setShow={setShow}
                        disabled={disabled}
                        disabledCode={disabledCode}
                        VOUVALUE={VOUVALUE}
                        VOUQTY={VOUQTY}
                        INCVOUQTY={INCVOUQTY}
                        POINTS={POINTS}
                        INCPOINTS={INCPOINTS}
                        INCTICKQTY={INCTICKQTY}
                        setVOUVALUE={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setVOUVALUE(0)
                          } else {
                            setVOUVALUE(val)
                          }
                        }}
                        setVOUVALUEOnBlur={(e) => {
                          if (e.target.value == "") {
                            setVOUVALUE(0)
                          } else {
                            setVOUVALUE(parseInt(e.target.value, 10).toFixed(2))
                          }
                        }}
                        setVOUQTY={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setVOUQTY(0)
                          } else {
                            setVOUQTY(val)
                          }
                        }}
                        setVOUQTYOnBlur={(e) => {
                          if (e.target.value == "") {
                            setVOUQTY(0)
                          } else {
                            setVOUQTY(parseFloat(e.target.value, 10))
                          }
                        }}
                        setINCVOUQTY={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setINCVOUQTY(0)
                          } else {
                            setINCVOUQTY(val)
                          }
                        }}
                        setINCVOUQTYOnBlur={(e) => {
                          if (e.target.value == "") {
                            setINCVOUQTY(0)
                          } else {
                            setINCVOUQTY(parseInt(e.target.value, 10))
                          }
                        }}
                        setPOINTS={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setPOINTS(0)
                          } else {
                            setPOINTS(val)
                          }
                        }}
                        setPOINTSOnBlur={(e) => {
                          if (e.target.value == "") {
                            setPOINTS(0)
                          } else {
                            setPOINTS(parseFloat(e.target.value, 10))
                          }
                        }}
                        setINCPOINTS={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setINCPOINTS(0)
                          } else {
                            setINCPOINTS(val)
                          }
                        }}
                        setINCPOINTSOnBlur={(e) => {
                          if (e.target.value == "") {
                            setINCPOINTS(0)
                          } else {
                            setINCPOINTS(parseFloat(e.target.value, 10))
                          }
                        }}
                        setINCTICKQTY={(e) => {
                          let val = Numeric(e.target, 8, 2, false)
                          if (val == "") {
                            setINCTICKQTY(0)
                          } else {
                            setINCTICKQTY(val)
                          }
                        }}
                        setINCROUNDS={(e) => {
                          let val = Numeric(e.target, 8, 0, false)
                          if (val == "") {
                            setINCROUNDS(0)
                          } else {
                            setINCROUNDS(val)
                          }
                        }}
                        INCROUNDS={INCROUNDS}
                        setINCROUNDSOnBlur={(e) => {
                          if (e.target.value == "") {
                            setINCROUNDS(0)
                          } else {
                            setINCROUNDS(parseInt(e.target.value, 10))
                          }
                        }}

                        setINCTICKQTYOnBlur={(e) => {
                          if (e.target.value == "") {
                            setINCTICKQTY(0)
                          } else {
                            setINCTICKQTY(parseInt(e.target.value, 10))
                          }
                        }}
                        groupBundle={groupBundle}
                        setGroupBundle={e => { setGroupBundle(e["value"]) }}
                        setItemBundle={e => { setItemBundle(e["value"]) }}
                        itemBundle={itemBundle}
                        allSkubundles={allItemBundles}
                        allSKUGrpBundles={allItemGroupBundles}
                        showAllFields={showAllFields}
                        pskubidAct={pskubidAct}
                        grpbidAct={grpbidAct}
                        diskperAct={diskperAct}
                        diskamtAct={diskamtAct}
                        fskbidAct={fskbidAct}
                        ticketAct={ticketAct}
                        ticketValue={ticketValue}
                        vouAct={vouAct}
                        pointAct={pointAct}
                        freeItemOnchange={(e) => {
                          setFreeIssueItem(e["value"])
                        }}
                        freeIssueItem={freeIssueItem}
                        ProDetailsTable={ProDetailsTable}
                        setProDetailsTable={setProDetailsTable}
                        TicketSet={ticketSet}
                        Ticket={ticket}
                        setTicket={e => { setTicket(e["value"]) }}

                      />
                    </TabPane>
                    <TabPane tabId="6">
                      <PromotionCouponContent
                        setCouponList={setCouponList}
                        couponList={couponList}
                        disabledCode={disabled}
                        couponFromDate={couponFromDate}
                        couponToDate={couponToDate}
                        couponBillvalueFrom={couponBillvalueFrom}
                        couponBillvalueTo={couponBillvalueTo}
                        couponFromDateOnchange={(e) => {
                          setCouponFromDate(e.target.value)
                        }}
                        couponToDateOnchange={(e) => {
                          setCouponToDate(e.target.value)
                        }}
                        couponBillvalueFromOnchange={(e) => {
                          var value = Numeric(e.target, 8, 2, false)
                          setCouponBillvalueFrom(value)
                        }}
                        couponBillvalueToOnchange={(e) => {
                          var value = Numeric(e.target, 8, 2, false)
                          setCouponBillvalueTo(value)
                        }}
                        couponBillvalueFromOnBlur={(e) => {
                          if (e.target.value == "") {
                            setCouponBillvalueFrom(0)
                          } else {
                            setCouponBillvalueFrom(parseFloat(e.target.value, 10).toFixed(2))
                          }
                        }}
                        couponBillvalueToOnblur={(e) => {
                          if (e.target.value == "") {
                            setCouponBillvalueTo(0)
                          } else {
                            setCouponBillvalueTo(parseFloat(e.target.value).toFixed(2))
                          }
                        }}
                        disabled={disabled}
                        triggerClear={triggerClear}
                        addNew={addNew}
                        selectCoupon={selectCoupon}
                      />
                    </TabPane>
                  </TabContent>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default PromotionMaster
